/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsGetConfig } from "../funcs/deviceIntegrationsGetConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DeviceIntegrationConfig } from "../models/components/deviceintegrationconfig.js";
import {
  GetDeviceIntegrationConfigRequest,
  GetDeviceIntegrationConfigSecurity,
} from "../models/operations/getdeviceintegrationconfig.js";
import { unwrapAsync } from "../types/fp.js";
export type DeviceIntegrationConfigQueryData = DeviceIntegrationConfig;

export function prefetchDeviceIntegrationConfig(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetDeviceIntegrationConfigRequest,
  security?: GetDeviceIntegrationConfigSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeviceIntegrationConfigQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeviceIntegrationConfigQuery(
  client$: GramCore,
  request: GetDeviceIntegrationConfigRequest,
  security?: GetDeviceIntegrationConfigSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DeviceIntegrationConfigQueryData>;
} {
  return {
    queryKey: queryKeyDeviceIntegrationConfig({
      provider: request.provider,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function deviceIntegrationConfigQueryFn(
      ctx,
    ): Promise<DeviceIntegrationConfigQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsGetConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeviceIntegrationConfig(
  parameters: {
    provider: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "getConfig", parameters];
}
